// 下边是比较单元格  合并单元格的方法
export function objectSpan({ column, rowIndex }, data, field, labelArr) {
    // console.log(rowIndex);
    // el 表格  存放表头的是label
    if (labelArr.includes(column.label)) {
        let _row = getSpanArr(data, field)[rowIndex];
        let _col = _row > 0 ? 1 : 0;
        // console.log( _row,_col);
        return {
            rowspan: _row,
            colspan: _col,
        };
    }
}
export function getSpanArr(data, field) {
    // console.log(2);
    let spanArr = [];
    let pos = 0;
    for (var i = 0; i < data.length; i++) {
        if (i === 0) {
            spanArr.push(1);
            pos = 0;
        } else {
            if (data[i][field] === data[i - 1][field]) {
                spanArr[pos] += 1;
                spanArr.push(0);
            } else {
                spanArr.push(1);
                pos = i;
            }
        }
    }
    return spanArr;
}